"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productContext = exports.ProductProvider = void 0;
var _react = require("react");
var _ProductBoxMode = require("../models/ProductBoxMode");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- context

const productContext = exports.productContext = /*#__PURE__*/(0, _react.createContext)({
  addToBasketMethod: undefined,
  code: '',
  hideSubscription: true,
  isLink: true,
  image: '',
  name: '',
  rating: 0,
  ratingCount: 0,
  url: '',
  mode: _ProductBoxMode.ProductBoxMode.Concept
});
const {
  Provider
} = productContext;
const ProductProvider = ({
  children,
  value: {
    hideSubscription = true,
    ...value
  }
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
  value: (0, _react.useMemo)(() => ({
    hideSubscription,
    ...value
  }), [hideSubscription, value]),
  children: children
});
exports.ProductProvider = ProductProvider;
//# sourceMappingURL=productContext.js.map